import { render, staticRenderFns } from "./programmingSubjectMore.vue?vue&type=template&id=1f4df90e&scoped=true"
import script from "./programmingSubjectMore.vue?vue&type=script&lang=js"
export * from "./programmingSubjectMore.vue?vue&type=script&lang=js"
import style0 from "./programmingSubjectMore.vue?vue&type=style&index=0&id=1f4df90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4df90e",
  null
  
)

export default component.exports